import { nanoid } from 'nanoid'
import React, { ChangeEvent, SelectHTMLAttributes, useEffect, useState } from 'react'
import Label from '@app/components/Label'
import { Icon } from '@iconify/react'
import S from './CountryField.styles'
import FieldError from '../FieldError/FieldError'

interface Option {
  value: string
  label: string
  flag?: string
}

interface CountryFieldProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string
  options: Option[]
  placeholder?: string
  /** Optional error component to render */
  error?: string
}

const CountryField = ({
  label,
  name = nanoid(),
  placeholder,
  options,
  error,
  onChange,
  onBlur,
  ...props
}: CountryFieldProps) => {
  const [value, setValue] = useState(props?.value || '')

  const select = (ev: ChangeEvent<HTMLSelectElement>) => {
    setValue(ev.currentTarget.value)
    onChange?.(ev)
  }

  // Update the value when the prop changes
  useEffect(() => {
    setValue(props.value || '')
  }, [props.value])

  return (
    <S.SelectField>
      {label && <Label htmlFor={name}>{label}</Label>}
      <S.Wrapper>
        <S.Flag>
          <Icon icon={`circle-flags:${options.find(o => o.value === value)?.flag ?? value}`} />
        </S.Flag>
        <S.Select id={name} name={name} value={value} onChange={select} onBlur={onBlur}>
          <option value="" disabled>
            {placeholder}
          </option>
          {options.map(o => (
            <option key={o.value} value={o.value}>
              {o.label}{' '}
            </option>
          ))}
        </S.Select>
        <S.Caret>
          <Icon icon="bx:chevron-down" fontSize={20} />
        </S.Caret>
      </S.Wrapper>
      <FieldError show={!!error} message={error} />
    </S.SelectField>
  )
}

export default CountryField
